import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { useParams } from "react-router";
import { fr } from "../i18n/fr";
import { groups, Logo } from "../ui/components";

/**
 * Target of the event link and QR code (SW-PU-01 to SW-PU-04), `/join/<identifier>#k=<key>`. The key after '#'
 * is never sent to the server: the page reads it in the browser only, to show it for a manual entry (DR17).
 */
export function JoinPage() {
  const { code } = useParams();
  const key = new URLSearchParams(window.location.hash.slice(1)).get("k") ?? "";
  const isAndroid = /Android/i.test(navigator.userAgent);
  // SW-PU-04: on a computer, the same link (key included, generated in the browser only) as a QR code to scan
  const [qr, setQr] = useState<string | null>(null);
  useEffect(() => {
    if (isAndroid) return;
    QRCode.toDataURL(window.location.href, { errorCorrectionLevel: "M", margin: 1, width: 280 }).then(setQr).catch(() => setQr(null));
  }, [isAndroid]);
  const openApp = () => {
    const fragment = window.location.hash; // "#k=..."
    const path = `join/${encodeURIComponent(code ?? "")}`;
    window.location.href = `intent://${window.location.host}/${path}${fragment}#Intent;scheme=https;package=fr.daredeville.secoursnav;S.browser_fallback_url=${encodeURIComponent(window.location.origin + "/app")};end`;
  };
  return (
    <div className="page narrow center">
      <div className="public-brand"><Logo size={40} /><h1>{fr.join.title}</h1></div>
      <p>{fr.join.text}</p>
      <div className="row center">
        <a className="button primary" href="/app">{fr.join.download}</a>
        {isAndroid && <button onClick={openApp}>{fr.join.open}</button>}
      </div>
      {!isAndroid && <p className="muted small">{fr.join.desktop}</p>}
      {code && /^[A-Za-z]{8}$/.test(code) && /^[0-9]{8}$/.test(key) && (
        <>
          <p className="muted small">{fr.join.manual}</p>
          <div className="join-access">
            <div className="field"><span>{fr.join.code}</span><code className="key">{groups(code.toUpperCase())}</code></div>
            <div className="field"><span>{fr.join.key}</span><code className="key">{groups(key)}</code></div>
          </div>
        </>
      )}
      {!isAndroid && qr && <div className="qr-wrap"><img src={qr} alt="QR code" className="qr" /><p className="muted small">{fr.join.scan}</p></div>}
    </div>
  );
}
